var _polygon, _rect, _path, _ellipse, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOokiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "136px",
    height: "50px",
    viewBox: "0 0 136 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ooki-logo-a",
    gradientUnits: "userSpaceOnUse",
    x1: 137.851,
    y1: -635.7874,
    x2: 66.3971,
    y2: -571.6544,
    gradientTransform: "matrix(1 0 0 -1 0 -571.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004cff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66d4ff"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#ooki-logo-a)",
    points: "105.5,14.4 94.8,28.9 94.8,3.1 84.2,3.1 84.2,49 94.8,49 94.8,35.2 105.6,49 119.7,49 104.9,32.1 119.7,14.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ooki-logo-b",
    gradientUnits: "userSpaceOnUse",
    x1: 150.3138,
    y1: -621.8782,
    x2: 78.8042,
    y2: -557.7003,
    gradientTransform: "matrix(1 0 0 -1 0 -571.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004cff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66d4ff"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 124.6,
    y: 14.4,
    fill: "url(#ooki-logo-b)",
    width: 10.6,
    height: 34.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ooki-logo-c",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9457,
    y1: -607.7003,
    x2: 91.5215,
    y2: -543.5945,
    gradientTransform: "matrix(1 0 0 -1 0 -571.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004cff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66d4ff"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ooki-logo-c)",
    d: "M129.9,12.3c1.8,0,3.2-0.6,4.4-1.8s1.8-2.6,1.8-4.4s-0.6-3.2-1.8-4.4c-1.2-1.2-2.6-1.8-4.4-1.8 s-3.2,0.6-4.4,1.8c-1.2,1.2-1.8,2.6-1.8,4.4s0.6,3.2,1.8,4.4C126.7,11.7,128.1,12.3,129.9,12.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ooki-logo-d",
    gradientUnits: "userSpaceOnUse",
    x1: 119.216,
    y1: -655.351,
    x2: 47.7913,
    y2: -591.2448,
    gradientTransform: "matrix(1 0 0 -1 0 -571.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004cff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66d4ff"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#ooki-logo-d)",
    cx: 60.2,
    cy: 30.5,
    rx: 19.4,
    ry: 19.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ooki-logo-e",
    cx: 57.1886,
    cy: -645.3253,
    r: 115.4541,
    gradientTransform: "matrix(.2912 .06588 .06563 -.2923 81.489 -166.698)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#0952ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004cff"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#ooki-logo-e)",
    cx: 60.2,
    cy: 30.5,
    rx: 19.4,
    ry: 19.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ooki-logo-f",
    cx: 93.9677,
    cy: -1164.0817,
    r: 214.3878,
    gradientTransform: "matrix(.2985 0 0 -.2997 -29.126 -334.795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffbe3b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#ffb445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#ff995e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#ff6d88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#ff6490"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#ooki-logo-f)",
    cx: 19.4,
    cy: 30.5,
    rx: 19.4,
    ry: 19.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOokiLogo);
export default __webpack_public_path__ + "static/media/ooki-logo.8a913672.svg";
export { ForwardRef as ReactComponent };